import { Col, List, Row } from "antd";
import React from "react";
import FilterProductItem from "./item";
import FilterProductSpecItem from "./specItem";
import "./style.scss";
import _ from "lodash";
import numeral from "numeral";
import { CATEGORY_IDS_SORT_BY_PRICE } from "../../common/constant";

const FilterProduct = (props: any) => {
  const { slug, product, specs, data, parentIndex } = props;

  const sortByPrice = (item: any) => {
    const _price = item.price || item[0].price;

    return numeral(_price.replaceAll(".", ",")).value();
  };

  const _data = CATEGORY_IDS_SORT_BY_PRICE.includes(product.cat_id || "")
    ? _.sortBy(data, [(item: any) => sortByPrice(item)])
    : data;

  return (
    <Row align="middle" justify="center" className="filter-product-wrapper">
      <Col span={24} style={{ width: "100%" }}>
        <Row
          justify="center"
          align="middle"
          className="filter-product-slider-wrapper">
          <Col span={24} style={{ width: "100%" }}>
            {product.is_drap ? (
              specs && specs.length ? (
                <List
                  className="filter-product-list"
                  // grid={{ lg: 4, md: 3, sm: 2, xs: 1 }}
                  dataSource={specs}
                  renderItem={(spec: any, i: number) => {
                    return (
                      <div className="filter-product-item-container">
                        <FilterProductSpecItem
                          {...props}
                          product={product}
                          spec={spec}
                          feature={data}
                          parentIndex={parentIndex}
                          index={i}
                        />
                      </div>
                    );
                  }}></List>
              ) : null
            ) : data && data.length ? (
              <List
                className="filter-product-list"
                // grid={{ lg: 4, md: 3, sm: 2, xs: 1 }}
                dataSource={_data}
                renderItem={(feature: any, i: number) => {
                  return (
                    <div className="filter-product-item-container">
                      <FilterProductItem
                        {...props}
                        slug={slug}
                        product={product}
                        feature={feature}
                        parentIndex={parentIndex}
                        index={i}
                      />
                    </div>
                  );
                }}></List>
            ) : null}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default FilterProduct;
